import React from 'react';
import PaginatedTable from '../Shared/PaginatedTable';

const BenefitsSection = ({ model }) => {
    const claims = model?.benefits || [];

    const columns = [
        { label: 'Policy Number', accessor: 'polNo' },
        { label: 'Description', accessor: 'description' },
        { label: 'Annual Premium', accessor: 'annualPremium' },
        { label: 'Monthly Amount', accessor: 'modalPremium' },
        { label: 'Amount', accessor: 'benefitAmt' },
    ];

    if (claims.length === 0) {
        return (
            <div className="container container-section" id="claims-history-container" >
                <div className="card notfoundbox rounded-3 shadow-lg" >
                    <div className="card-body" >
                        <div className="flex-container" >
                            <h5>No Benefits Found </h5>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="container container-section" id="claims-history-container" >
            <PaginatedTable columns={columns} data={claims} />
        </div>
    );
};

export default BenefitsSection;
